module.exports = window["Bernie_l10nBundle_da_DK"];